import styled, { css } from "styled-components";


export const ThreeDModel = styled.div`
  position: relative;
  width: 100%;
  max-width: 740px;
  max-height: 1000px;
  height: 100%;
  margin: 0px auto;

  &.simple-threed-configurator-model{
    height:calc(100vh - 60px - 35px);
  } 

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {    
		&.simple-threed-configurator-model #threngine_canvas{
      height:calc(100vh - 70px - 350px) !important;
    }
	}  

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.veryLowHeight}px) {		
		&.simple-threed-configurator-model #threngine_canvas{
      height:calc(100vh - 70px - 250px) !important;
    }
    
  }
`;

export const ThreeDModelContainer = styled.div<{menuStyle:string, currentMenuTab:number, mobile:boolean, fullSize:boolean, modelVisible:boolean}>`
  position: relative;

  display: flex;
  flex: auto;

  justify-content: center;
  align-items: center;

  overscroll-behavior: none;
  touch-action: none;
  user-select: none;

  & canvas {
    overscroll-behavior: none;
    touch-action: none;
    user-select: none;
  }

  &.simple-threed-configurator-model-container{
    align-items:start;
  }

  ${(props) => props.mobile && css`
    height: 40%;
    max-height: 40vh;
    z-index: 12;

    & ${ThreeDModel} {
      max-width: unset;
      max-height: 120vw;
    };
  `};

  ${(props) => props.mobile && props.menuStyle === "luxe" && css`
    height: 50%;
    max-height: 50vh;

    & ${ThreeDModel} {
      max-height: 93%;
      align-self: flex-end;
    };
  `};

  ${(props) => props.mobile && props.currentMenuTab < 0 && css`
    height: calc(100% - ${props.theme.footerHeight}px);
    max-height: calc(100vh - ${props.theme.footerHeight}px);
  `};

  ${(props) => props.mobile && props.fullSize && css`
    max-height: unset;
    height: 100%;

    & ${ThreeDModel} {
      max-width: unset;
      max-height: unset;
    };
  `};

  ${(props) => props.mobile && props.fullSize && props.menuStyle === "luxe" && css`
    & ${ThreeDModel} {
      max-height: 80%;
      align-self: center;
    };
  `};

  ${(props) => !props.modelVisible && css`
    & ${ThreeDModel} {
      opacity: 0;
    };
  `};

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {    
    &.simple-threed-configurator-model-container{
      align-items:center;
    }
    & ${ThreeDModel}.simple-threed-configurator-model{
      max-height:calc(100vh - 70px - 250px);
    }
	}  
`;